import React, { Fragment, useCallback, useRef, useState } from 'react'

import { useRouter } from 'next/navigation'

import { CaretDown, List, X } from '@phosphor-icons/react'
import { Accordion, Row, Text } from 'Components/UI'

import { TRANSITION } from 'Constants/Animations'
import { NAVIGATION_BASE, NAVIGATION_DROPDOWN } from 'Constants/Navigation'

import { useOnClickOutside } from 'Hooks'

import {
  Container,
  ControlButton,
  Divider,
  NavButton,
  Overflow,
  StyledButton,
} from './styles'

function MobileNavigation() {
  const router = useRouter()

  const menuRef = useRef(null)

  const [menuVisible, setMenuVisible] = useState(false)
  const [accordionUnfolded, setAccordionUnfolded] = useState(false)

  const handleClick = useCallback(
    (path: string) => {
      setMenuVisible(false)
      setAccordionUnfolded(false)

      router.push(path)
    },
    [router],
  )

  useOnClickOutside(menuRef, () => setMenuVisible(false))

  return (
    <Row relative>
      <ControlButton onClick={() => setMenuVisible(prevState => !prevState)}>
        <List size={32} weight="bold" />
      </ControlButton>

      <Overflow
        animate={{ opacity: menuVisible ? 1 : 0 }}
        transition={TRANSITION.DEFAULT}
      />

      <Container
        animate={{ width: menuVisible ? '300px' : '0px' }}
        initial={{ width: '0px' }}
        ref={menuRef}
        transition={TRANSITION.DEFAULT}
      >
        <Row fullWidth justifyEnd p={5}>
          <ControlButton
            onClick={() => setMenuVisible(prevState => !prevState)}
          >
            <X size={32} weight="bold" />
          </ControlButton>
        </Row>

        {NAVIGATION_BASE.map(item => (
          <Fragment key={item.id}>
            <Divider />

            <NavButton key={item.id} onClick={() => handleClick(item.path)}>
              <Text important medium nowrap screen14>
                {item.label}
              </Text>
            </NavButton>
          </Fragment>
        ))}

        <Divider />

        <StyledButton
          iconRotated={accordionUnfolded}
          onClick={() => setAccordionUnfolded(prevState => !prevState)}
        >
          <Text important medium nowrap screen14>
            Clubhouse
          </Text>

          <CaretDown weight="bold" />
        </StyledButton>

        <Accordion isOpen={accordionUnfolded}>
          {NAVIGATION_DROPDOWN.map(item => (
            <Fragment key={item.id}>
              <Divider />

              <NavButton key={item.id} onClick={() => handleClick(item.path)}>
                <Text important medium screen14>
                  {item.label}
                </Text>
              </NavButton>
            </Fragment>
          ))}
        </Accordion>

        <Divider />
      </Container>
    </Row>
  )
}

export default MobileNavigation
